import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./hooks/useAuth";
import {BrowserRouter} from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const root = ReactDOM.createRoot(document.getElementById('root'));

const defaultTheme = createTheme();

root.render(
  <React.StrictMode>
    <BrowserRouter>
        <AuthProvider>
            <ThemeProvider theme={defaultTheme}>
                <App />
            </ThemeProvider>
        </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
